/* import __COLOCATED_TEMPLATE__ from './response-mapping.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();